// Gatsby Requirements
import React, { useState, useEffect } from 'react'
import { storyblokEditable } from "gatsby-source-storyblok";


const Id = ({ data }) => {

    const [isEditor, setEditor] = useState(false);

    useEffect(() => {
        if (window.location.search.includes('_storyblok')) {
            setEditor(true);
        }
    }, []);

    return (
        <div style={{display: 'block'}} id={data.id} {...storyblokEditable(data)}>
            {isEditor && 
                <div className='wrapper' style={{margin: '1em auto', textAlign: 'center', backgroundColor: 'rgb(236, 236, 236)'}}>
                    <p style={{margin: '0'}}>Anchor ID: <strong>#{data.id}</strong>. This is only visible to you inside Storyblok. <button onClick={() => setEditor(false)}>Hide me</button></p>
                </div>
            }
        </div>
    )
}

export default Id